import { BaseAssertException } from '../exceptions/base-assert.exception';
import { IllegalArgumentException } from '../exceptions/illegal-argument.exception';
import { Matchers } from '../matchers';

export function nonNullable<T>(
  value: T | undefined | null,
  message: () => string = () => 'value must be defined',
  construct: new (message: string) => BaseAssertException = IllegalArgumentException,
): asserts value is NonNullable<T> {
  if (!Matchers.isDefined(message).apply(value)) {
    throw new construct(message());
  }
}
